import type { Filter, FiltersGroup, FiltersGroups } from '@/app/common/filters/core/filtersTypes.ts';
import { filterTypeOf } from '@/app/common/filters/types/filterTypeBehaviour.ts';

export const isFilterSelected = (filter: Filter): boolean => filterTypeOf(filter).isSelected(filter);

export const getSelectedFiltersCount = (filtersGroups: FiltersGroups): number =>
  filtersGroups.reduce(
    (count, group) =>
      'filters' in group ? count + (group as FiltersGroup).filters.filter(isFilterSelected).length : count,
    0
  );
